






























































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import EquipmentCard from '../components/EquipmentCard.vue';
import EquipmentForm from '../components/EquipmentForm.vue';
import { equipments, layout } from '@/modules/shared/shared/store/namespaces';
import { LayoutMutations } from '@/modules/shared/layouts/store/layout.mutations';
import { LayoutTitle } from '@/modules/shared/layouts/domain/layout-title';
import SectionTitle from '@/modules/shared/shared/components/SectionTitle.vue';
import { EquipmentOptions } from '@/modules/equipments/domain/equipment-options';
import { EquipmentsActions } from '@/modules/equipments/store/equipments.actions';
import { EquipmentsGetters } from '@/modules/equipments/store/equipments.getters';
import { EquipmentsResult } from '@/modules/equipments/domain/equipments.result';
import { DatacenterEquipments } from '@/modules/reports/shared/domain/datacenter-equipments';
import { EventBus } from '@/main';
import { EventBusMessages } from '@/modules/shared/shared/domain/constants/event-bus-messages';

@Component({
    components: {
        SectionTitle,
        EquipmentCard,
        EquipmentForm,
    },
})
export default class Equipments extends Vue {
    buildingOption: number = -1;
    createMode: boolean = true;
    dataCenterOption: number = -1;
    deleteDialog: boolean = false;
    deletingEquipment: boolean = false;
    dialog: boolean = false;
    equipmentDeleted: boolean = false;
    equipmentFormKey: number = 0;
    equipmentToDelete: {
        buildingEquipmentIds: number[];
        name: string;
    } = {
        buildingEquipmentIds: [],
        name: '',
    };
    equipmentToUpdate: {
        id: number;
        name: string;
        buildingsDataCentersSelected: number[];
        parametersSelected: number[];
    } = {
        id: -1,
        name: '',
        buildingsDataCentersSelected: [],
        parametersSelected: [],
    };
    finishedText: string = '';
    limit: number = 6;
    loadingEquipments: boolean = false;
    loadingText: string = '';
    page: number = 1;
    search: string = '';

    $refs!: {
        form1: any;
    };

    async mounted() {
        this.changeTitle({ title: 'Administración', route: ['EQUIPOS'] });
        this.loadingEquipments = true;
        await this.getEquipments();
        await this.getDataCentersAndBuildings();
        this.loadingEquipments = false;
    }

    @Watch('buildingOption')
    onBuildingOptionChanged() {
        this.getEquipments();
    }

    @Watch('dataCenterOption')
    onDataCenterOptionChanged() {
        this.$refs.form1.reset();
        this.getEquipments();
    }

    @Watch('search')
    async onSearchChanged() {
        if (!this.search) {
            await this.getEquipments();
        }
    }

    get buildingOptions() {
        let buildingOptions: {
            id: number;
            name: string;
        }[] = [];
        if (this.dataCentersAndBuildings && this.dataCentersAndBuildings.length) {
            if (!this.dataCenterOption || this.dataCenterOption === -1) {
                this.dataCentersAndBuildings.forEach(dataCenter => {
                    dataCenter.buildingsDataCenters.forEach(buildingDataCenter => {
                        let buildings: any = buildingOptions.find(building => {
                            return building.id === buildingDataCenter.building.id;
                        });
                        if (!buildings) {
                            let buildingOption: {
                                id: number;
                                name: string;
                            } = {
                                id: buildingDataCenter.building.id,
                                name: buildingDataCenter.building.name,
                            };
                            buildingOptions.push(buildingOption);
                        }
                    });
                });
            } else {
                let dataCenterAux: any = this.dataCentersAndBuildings.find(dataCenter => {
                    return dataCenter.id === this.dataCenterOption;
                });

                if (dataCenterAux) {
                    dataCenterAux.buildingsDataCenters.forEach(buildingDataCenter => {
                        let buildingOption: {
                            id: number;
                            name: string;
                        } = {
                            id: buildingDataCenter.building.id,
                            name: buildingDataCenter.building.name,
                        };
                        buildingOptions.push(buildingOption);
                    });
                }
            }
        }
        return buildingOptions;
    }
    get dataCenterOptions() {
        let dataCenterOptions: {
            id: number;
            name: string;
        }[] = [];

        if (this.dataCentersAndBuildings && this.dataCentersAndBuildings.length) {
            this.dataCentersAndBuildings.forEach(dataCenter => {
                let dataCenterOption: {
                    id: number;
                    name: string;
                } = {
                    id: dataCenter.id,
                    name: dataCenter.name,
                };
                dataCenterOptions.push(dataCenterOption);
            });
        }
        return dataCenterOptions;
    }

    async getEquipments() {
        let equipmentsOptions: EquipmentOptions = {
            limit: this.limit,
            start: this.page,
            dataCenter:
                this.dataCenterOption && this.dataCenterOption !== -1
                    ? this.dataCenterOption
                    : null,
            building:
                this.buildingOption && this.buildingOption !== -1 ? this.buildingOption : null,
            keyword: this.search,
        };

        const failed = await this.fetchEquipments(equipmentsOptions);
        if (failed) {
            failed.showError();
        }
    }
    get pages() {
        if (this.equipmentsResult.pages) {
            if (this.page > this.equipmentsResult.pages) {
                this.page = this.equipmentsResult.pages;
                if (this.page !== 0) {
                    this.getEquipments();
                } else {
                    this.page = 1;
                }
            }
            return this.equipmentsResult.pages;
        } else {
            return 1;
        }
    }

    closeDialog(reload: boolean) {
        this.dialog = false;
        if (reload) {
            this.getEquipments();
        }
    }

    async deleteEquipment() {
        this.loadingText = 'Eliminando equipo';
        this.finishedText = 'Equipo eliminado exitosamente';
        this.deletingEquipment = true;
        let buildingEquipmentIds = this.equipmentToDelete.buildingEquipmentIds;

        let error = false;
        await Promise.all(
            buildingEquipmentIds.map(async buildingEquipmentId => {
                const failed = await this.deleteAnEquipment(buildingEquipmentId);
                if (failed) {
                    failed.showError();
                    error = true;
                }
            }),
        );
        if (!error) {
            EventBus.$emit(EventBusMessages.SHOW_SUCCESS, this.finishedText);
        }

        this.equipmentDeleted = true;
        this.deletingEquipment = false;
        this.deleteDialog = false;
    }

    async getDataCentersAndBuildings() {
        const failed = await this.fetchDatacenters();
        if (failed) {
            failed.showError();
        }
    }

    openDeleteDialog() {
        this.deletingEquipment = false;
        this.equipmentDeleted = false;
        this.deleteDialog = true;
    }

    reRenderEquipmentForm() {
        this.createMode = true;
        if (this.equipmentFormKey !== 0) {
            this.equipmentFormKey = 0;
        } else {
            this.equipmentFormKey = 1;
        }
    }

    setEquipmentDeletion(buildingEquipmentIds, equipmentName) {
        this.equipmentToDelete.buildingEquipmentIds = buildingEquipmentIds;
        this.equipmentToDelete.name = equipmentName;
        this.openDeleteDialog();
    }

    updateEquipment(equipment: {
        id: number;
        name: string;
        parameters: {
            id: number;
            name: string;
            measureUnit: string;
        }[];
        dataCenters: {
            id: number;
            name: string;
            buildingDataCenter: {
                id: number;
                building: {
                    id: number;
                    name: string;
                };
            }[];
        }[];
    }) {
        let equipmentToUpdate: {
            id: number;
            name: string;
            buildingsDataCentersSelected: number[];
            parametersSelected: number[];
        } = {
            id: equipment.id,
            name: equipment.name,
            buildingsDataCentersSelected: [],
            parametersSelected: [],
        };

        equipment.parameters.forEach(parameter => {
            equipmentToUpdate.parametersSelected.push(parameter.id);
        });

        equipment.dataCenters.forEach(dataCenter => {
            dataCenter.buildingDataCenter.forEach(buildingDataCenter => {
                equipmentToUpdate.buildingsDataCentersSelected.push(buildingDataCenter.id);
            });
        });

        if (!this.dialog) {
            this.reRenderEquipmentForm();
        }
        this.createMode = false;
        this.equipmentToUpdate = equipmentToUpdate;
        this.dialog = true;
    }

    @layout.Mutation(LayoutMutations.CHANGE_TITLE)
    changeTitle!: (layout: LayoutTitle) => void;

    @equipments.Action(EquipmentsActions.FETCH_EQUIPMENTS)
    fetchEquipments!: (options: EquipmentOptions) => Promise<RequestResponse>;

    @equipments.Action(EquipmentsActions.FETCH_DATACENTERS)
    fetchDatacenters!: () => Promise<RequestResponse>;

    @equipments.Action(EquipmentsActions.DELETE_EQUIPMENT)
    deleteAnEquipment!: (buildingEquipmentId: number) => Promise<RequestResponse>;

    @equipments.Getter(EquipmentsGetters.GET_EQUIPMENTS)
    equipmentsResult!: EquipmentsResult;

    @equipments.Getter(EquipmentsGetters.GET_DATACENTERS)
    dataCentersAndBuildings!: DatacenterEquipments[];
}
